import axios from 'axios';
import refreshToken from './refreshToken';
import Cookies from 'js-cookie';

const getBaseUrl = () => {
  const currentHost = window.location.hostname;

  if (currentHost.includes("peoples.myft.yourfavorite.agency")) {
    return process.env.REACT_APP_PEOPLE_URL;
  } else if (currentHost.includes("animals.myft.yourfavorite.agency")) {
    return process.env.REACT_APP_ANIMALS_URL;
  }

  return process.env.REACT_APP_PEOPLE_URL;
};

const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});

axiosInstance.interceptors.request.use((config) => {
  const csrfToken = Cookies.get("csrftoken");
  const accessToken = Cookies.get("access");

  if (accessToken) config.headers['Authorization'] = `Bearer ${accessToken}`;
  if (csrfToken) config.headers['X-CSRFToken'] = csrfToken;

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await refreshToken();
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

        return axiosInstance(originalRequest);
      } catch (err) {
        Cookies.remove("access");
        Cookies.remove("refresh");
        Cookies.remove("csrftoken");

        return Promise.reject(err);
      }
    }
    return Promise.reject(error)
  }
)

export default axiosInstance;
